export default __webpack_public_path__ + "a7193b007f033b134ae264c24d60adef.png";